
import { computed, defineComponent, PropType } from 'vue';
import { useVModel } from 'vue-composable';
import { useStore } from '@/store';
import { Option } from '@/types';
import { Client } from '@/types/app';
import FilterableSelect from '@/components/form-controls/base/FilterableSelect.vue';

export default defineComponent({
  name: 'ClientsSelect',
  emits: ['update:modelValue', 'input'],
  components: {
    FilterableSelect
  },
  props: {
    modelValue: {
      type: Object as PropType<Omit<Client, 'id'>>,
      required: false
    },
    required: {
      type: Boolean
    },
    border: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  setup(props) {
    const store = useStore();
    const clientState = useVModel(props, 'modelValue');
    const clients = computed(() => store.getters.clients.get);

    const clientOptions = computed<Array<Option<Client>>>(() =>
      clients.value.map(client => ({
        label: `${client.name}  |  ${client.phone}${client.email ? `  |  ${client.email}` : ''}`,
        value: client
      }))
    );

    return {
      clientOptions,
      clientState
    };
  }
});
